import React from "react";
import { currencyFormatter } from "oautils/oaCommonUtils";

const FlightTicketFare = (props) => {
  return (
    <div className="fare-details-table-container" style={{ width: "100%" }}>
      <table className="fare-details-table" style={{ width: "100%" }}>
        <thead>
          <tr style={{ backgroundColor: "#eee" }}>
            <th className="text-align-left">Fare Details</th>
            <th className="text-align-right">Amount (INR)</th>
          </tr>
        </thead>
        <tbody>
          <tr style={{ border: "1px solid #FAFAFA" }}>
            <td
              style={{ border: "1px solid #FAFAFA" }}
              className="text-align-left"
            >
              Base Fare
            </td>
            <td
              style={{ border: "1px solid #FAFAFA" }}
              className="text-align-right"
            >
              {currencyFormatter(props?.basefare)}
            </td>
          </tr>
          <tr>
            <td
              style={{ border: "1px solid #FAFAFA" }}
              className="text-align-left"
            >
              Airline Taxes and Fees
            </td>
            <td
              style={{ border: "1px solid #FAFAFA" }}
              className="text-align-right"
            >
              {currencyFormatter(parseInt(props?.taxes))}
            </td>
          </tr>
          <tr>
            <td
              style={{ border: "1px solid #FAFAFA" }}
              className="text-align-left"
            >
              Airline GST
            </td>
            <td
              style={{ border: "1px solid #FAFAFA" }}
              className="text-align-right"
            >
              {currencyFormatter(props?.gst)}
            </td>
          </tr>
          <tr>
            <td
              style={{ border: "1px solid #FAFAFA" }}
              className="text-align-left"
            >
              Meal/Seat/Baggage/Misc Charges
            </td>
            <td
              style={{ border: "1px solid #FAFAFA" }}
              className="text-align-right"
            >
              {currencyFormatter(props?.mealbaggage)}
            </td>
          </tr>
          <tr>
            <td
              style={{ border: "1px solid #FAFAFA" }}
              className="text-align-left"
            >
              <b>Total</b>
            </td>
            <td
              style={{ border: "1px solid #FAFAFA" }}
              className="text-align-right"
            >
              <b>{currencyFormatter(parseInt(props?.total))}</b>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default FlightTicketFare;
